import RoleLabel from 'components/atoms/RoleLabel'
import * as React from 'react'
import { IUser } from 'static/interfaces'
import styled from 'styled-components'
import * as constants from '../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  user: IUser
  previewImage: any
  setPreviewCoverImage: React.Dispatch<any>
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}

export const ProfileEditHeader: React.FC<IProps> = ({
  user,
  previewImage,
  setPreviewCoverImage,
  setShowModal,
}) => {
  return (
    <ProfileEditHeaderWrapper className={user.guest ? 'guest-user' : ''}>
      <PanelHeaderContent>
        <Avatar onClick={() => setShowModal(true)}>
          <img src={previewImage ? previewImage.url : user.avatar_url} />
          <SubButton size={112}>
            <SvgIcon
              name="photo_camera"
              className="icon camera"
              ariaHidden={true}
              role="presentation"
            />
          </SubButton>
        </Avatar>
        <div className="Profile_Info hideMobile">
          <p className="Profile_Name">{user.guest ? user.username : user.fullname}</p>
          <RoleLabel user={user} />
        </div>
      </PanelHeaderContent>
      {!user.guest && !user.admin && (
        <>
          <PanelHeaderContent>
            <label htmlFor="coverFile">
              <SubButton size={32}>
                <SvgIcon
                  name="photo_camera"
                  className="icon camera"
                  ariaHidden={true}
                  role="presentation"
                />
              </SubButton>
              <input
                id="coverFile"
                type="file"
                accept="image/png, image/jpeg"
                onChange={event => {
                  setPreviewCoverImage({
                    file: event.currentTarget.files[0],
                    url: URL.createObjectURL(event.currentTarget.files[0]),
                  })
                }}
              />
            </label>
            <SubButton size={32} onClick={() => setPreviewCoverImage(null)} className="hideMobile">
              <SvgIcon name="close" className="icon camera" ariaHidden={true} role="presentation" />
            </SubButton>
          </PanelHeaderContent>
        </>
      )}
    </ProfileEditHeaderWrapper>
  )
}
const ProfileEditHeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  max-width: 1200px;
  margin: 0 auto;
  height: 200px;
  padding: 0 80px;
  @media screen and (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 0 50px;
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    padding: 0 16px;
    height: 100px;
    &.guest-user {
      justify-content: center;
      margin-top: 8px;
    }
  }
`
const PanelHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .hideMobile {
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      display: none;
    }
  }
  > label {
    cursor: pointer;
    padding: 4px 8px;
    font-size: 14px;
  }

  input[type='file'] {
    display: none;
  }

  .Profile_Info {
    margin-left: 20px;
  }
  .Profile_Name {
    max-width: 270px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
  }
`

const SubButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${constants.COLORS.subText};
  background-color: rgba(255, 255, 255, 0.5);
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid ${constants.COLORS.divider};

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    width: ${({ size }) => size / 2}px;
    height: ${({ size }) => size / 2}px;
    .guest-user & {
      width: 80px;
      height: 80px;
    }
  }

  &:hover {
    opacity: 0.8;
  }
  .icon {
    width: 24px;
    height: 24px;
  }
`

const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 112px;
  height: 112px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    width: 56px;
    height: 56px;
    .guest-user & {
      width: 80px;
      height: 80px;
    }
  }
  border-radius: 50%;
  }
  > img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    display: block;
    object-fit: cover;
    border-radius: 50%;
  }
  .camera {
    pointer-events: none;
    width: 40px;
    height: 40px;
    color: ${constants.COLORS.subText};
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 24px;
      height: 24px;
    }
  }
`
